import * as types from "../actions/ActionTypes";
import { initialArrayValues } from "../store/InitialStore";
export default function LocationCodeListReducer(
  state = initialArrayValues,
  action
) {
  const { type, payload } = action;
  switch (type) {
    case types.LOCATION_CODE_LISTING_LOADING:
      return { loading: true, data: [] };
    case types.LOCATION_CODE_LISTING_SUCCESS:
      return { loading: false, data: payload };
    default:
      return state;
  }
}
